import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullableNumber',
  standalone: true
})
export class NullableNumberPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    format: string = '1.0-0',
    fallback: string = 'N/A'
  ): string {
    if (value === null || value === undefined) {
      return fallback;
    }
  
    // Clamp near-zero values BEFORE formatting
    const EPS = 0.05; // matches 1 decimal rounding
    if (Math.abs(value) < EPS) {
      value = 0;
    }
  
    // Normalize negative zero explicitly
    if (Object.is(value, -0)) {
      value = 0;
    }
  
    const [_, maxDigits] = format.split('-').map(v => parseInt(v, 10));
    const maximumFractionDigits = isNaN(maxDigits) ? 0 : maxDigits;
  
    const userLocale = navigator.language || 'en-US';
  
    return new Intl.NumberFormat(userLocale, {
      maximumFractionDigits
    }).format(value);
  }
  
}
